import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import NewsList from "./components/news-list/NewsList";
import NewsItemModal from "./components/newsItem-modal";
import {useNewsController} from "../../controllers/news-controller";
import {Input} from "antd";
import {useAuth} from "../../context/authContext";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import React, {useEffect, useState} from "react";
import "./style.less"
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import {useSearchParams} from "react-router-dom";
import {SearchOutlined} from "@ant-design/icons";

const NewsPage = () => {

  const {
    isCreateModalOpen,
    toggleCreateNewsModalOpen,
    isLoading,
    newsList,
    confirmDeleteNews,
    createNewsHandler,
    selectedNewsItem,
    editButtonHandler,
    DEFAULT_PAGE_SIZE,
    totalNewsCount,
    onPageChange,
    setSearchValue,
    updateNews,
    currentPage,
    searchValue
  } = useNewsController()

  const [searchTitle, setSearchTitle] = useState(searchValue);
  const [, setSearchParams] = useSearchParams()

  useEffect(() => {
    const handler = setTimeout(() => {
      const normalizedSearch = searchTitle.trim()
      setSearchValue(normalizedSearch);
      if (normalizedSearch !== searchValue) onPageChange(1);
    }, 450);

    return () => clearTimeout(handler);
  }, [searchTitle]);

  useEffect(() => {
    const params = new URLSearchParams()
    if (searchValue) params.set("search", searchValue)
    if (currentPage > 1) params.set("page", String(currentPage))
    setSearchParams(params, {replace: true})
  }, [searchValue, currentPage, setSearchParams])


  const {canManageContent} = useAuth()

  const headerActions = <>
    {canManageContent && <AddActionButton onClick={toggleCreateNewsModalOpen}/>}
    <Input className="news-page__search" prefix={<SearchOutlined/>} allowClear value={searchTitle} placeholder="Пошук новин" onChange={(e) => setSearchTitle(e.target.value)}/>
  </>


  return <div className="news-page">
    <div className="page_title news-page__header">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">Новини</div>
          </div>
        }
        extra={headerActions}
        onBack={navigateBackHandler}
      />
    </div>
    <div className='page_content news-page__content'>
      <NewsList isLoading={isLoading} editButtonHandler={editButtonHandler}
                newsList={newsList}
                confirmDeleteNews={confirmDeleteNews} pageSize={DEFAULT_PAGE_SIZE}
                totalCount={totalNewsCount} onPageChange={onPageChange} currentPage={currentPage}/>
    </div>
    {isCreateModalOpen && <NewsItemModal updateNewsHandler={updateNews} selectedNewsItem={selectedNewsItem}
                                         isModalOpen={isCreateModalOpen}
                                         toggleModalOpen={toggleCreateNewsModalOpen}
                                         createNewsHandler={createNewsHandler}
                                         isLoading={isLoading}/>}
    <ScrollToTopButton elementSelector={".page_content"}/>
  </div>
}

export default NewsPage
